"use client";

import { useEffect, useState } from "react";

type AnimatedProgressBarProps = {
  progress: number; // target value from 0 to 100
  duration?: number; // total animation duration in ms (default: 1000ms)
};

export function AnimatedProgressBar({
  progress,
  duration = 1000,
}: AnimatedProgressBarProps) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const steps = progress;
    const intervalTime = duration / steps;

    const interval = setInterval(() => {
      setCurrent((prev) => {
        const next = prev + 1;
        if (next >= progress) {
          clearInterval(interval);
          return progress;
        }
        return next;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [progress, duration]);

  return (
    <div className="w-full h-1 bg-background rounded-md overflow-hidden">
      <div
        className="h-full bg-white transition-all duration-100 ease-in-out"
        style={{ width: `${current}%` }}
      />
    </div>
  );
}
